export enum AddOnIcon {
  'bullseye',
  'camera',
  'video'
}
